/**
 * Valores iniciais do formulário de Membership (template de plano).
 * 
 * Deve estar alinhado com:
 * - membershipSchema.js (validação Yup)
 * - membershipConverter.js (toFirestore)
 * - MembershipEditor.js (UI do formulário)
 * - membershipDefaults (este arquivo)
 */
export const membershipDefaults = {
    name: "",
    type: "fixed",                      // "fixed" | "pass"
    durationType: "monthly",            // "monthly" | "yearly" | "days" | "classes"
    duration: 1,
    value: 0,                           // Valor base do plano (R$)
    maxInstallments: 1,
    description: "",
    status: "active",                   // "active" | "inactive"

    // Regras de Cancelamento
    allowsCancellationByApp: false,
    cancellationFee: 0,
    cancellationNoticeDays: 30,

    // Regras de Suspensão/Trancamento
    allowsSuspension: false,
    maxSuspensionDays: 0,
    suspensionFee: 0,

    // Matrícula & Acessos
    enrollmentRequired: false,
    maxSessionsPerWeek: 0,              // 0 para ilimitado
    allowedDaysOfWeek: [],              // Array de [0-6], Vazio para todos os dias
    classPackageValidityMonths: 6,      // Validade do pacote de aulas (em meses)


    // Premiação (Experiência/Pontos)
    memberXp: 0,
    employeeXp: 0,

    // Ordenação na sidebar
    order: 0
};
